export enum SpecialRateFor {
  CUSTOMER = "Customer",
  PROJECT = "Project",
}

export const SpecialRateLocalKeys = {
  CUSTOMER: "customer-id",
  PROJECT: "project-id",
};

export const SpecialRateToastMessages = {
  CREATE: "Special rate added successfully",
  UPDATE: "Special rate updated successfully",
};
